// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.padding[data-v-6d9f308a] {\n\tpadding: 20px;\n}\n.centre[data-v-6d9f308a] {\n\ttext-align: center;\n}\n.button[data-v-6d9f308a] {\n\tmax-width: 88px;\n}\n.margin[data-v-6d9f308a] {\n\tmargin: auto;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
